<div class="atlas-navbar__title" role="region" aria-label="Partner identity">
  <div
    class="atlas-navbar__title__content atlas-navbar__transition"
    [class.atlas-navbar__title--interactable]="isInteractable"
    >
    @if (!!icon) {
      <i class="material-icons atlas-navbar__title__icon">
        {{ icon }}
      </i>
    }
    <div class="atlas-navbar__title__text">
      <ng-content></ng-content>
    </div>
  </div>
</div>
